import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import allowanceDetail from "../../../containers/modules/hr/allowance-detail";

export default function AllowanceDetailRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="allowance-detail"
      index
      element={
        <AccessControl
          name={"Allowance Detail List"}
          auth={authUser}
          component={allowanceDetail}
        />
      }
    ></Route>
  );
}
